import React from 'react';
import { Link } from 'react-router-dom';
import s from './PageHero.module.css';

export default function PageHero({ eyebrow, title, subtitle, image, breadcrumbs, cta }) {
  return (
    <div className={s.hero} style={{ backgroundImage: image ? `url(${image})` : undefined }}>
      <div className={s.overlay}></div>
      <div className="container">
        <div className={s.content}>
          {breadcrumbs && (
            <nav className={s.breadcrumbs} aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              {breadcrumbs.map((b, i) => (
                <React.Fragment key={i}>
                  <span className={s.sep}>›</span>
                  {b.path ? <Link to={b.path}>{b.label}</Link> : <span>{b.label}</span>}
                </React.Fragment>
              ))}
            </nav>
          )}
          {eyebrow && <p className={s.eyebrow}>{eyebrow}</p>}
          <h1 className={s.title} dangerouslySetInnerHTML={{ __html: title }} />
          {subtitle && <p className={s.subtitle}>{subtitle}</p>}
          {cta && (
            <div className={s.actions}>
              <Link to="/book-appointment" className="btn btn-primary btn-primary-lg">{cta}</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
